import { ReactElement, useCallback } from "react";
import { Dialog } from "../Dialog/Dialog";
import { DialogHeader } from "../Dialog/DialogHeader/DialogHeader";
import { localize } from "client_legacy/ndaw/culture";
import { DialogBody } from "../Dialog/DialogBody/DialogBody";
import { DialogFooter } from "../Dialog/DialogFooter/DialogFooter";
import { Toolbar } from "../Toolbar/Toolbar";
import styles from "./SaveChangesDialog.module.less";
import { useDataInputDialog } from "client/Hooks";

export type SaveChangesDialogProps = {
	onConfirm(shouldSave: boolean): void;
	onClose(): void;
};

export const SaveChangesDialog = (props: SaveChangesDialogProps): ReactElement => {
	const {
		onConfirm,
		onClose
	} = props;

	return (
		<Dialog trackingId="save-changes-dialog">
			<DialogHeader
				title={localize("_DoYouWantToSaveTheChanges")}
			/>
			<DialogBody>
				<p className={styles.message}>
					{localize("_ThereAreUnsavedChangesToThisPage")}
				</p>
			</DialogBody>
			<DialogFooter>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_Save")}
						onClick={() => onConfirm(true)}
						trackingId="save"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_DontSave")}
						onClick={() => onConfirm(false)}
						trackingId="dont-save"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
						trackingId="cancel"
					/>
				</Toolbar>
			</DialogFooter>
		</Dialog>
	);
};
SaveChangesDialog.displayName = "SaveChangesDialog";

export function useSaveChangesDialog(): [
	element: ReactElement | null,
	open: () => Promise<TryResult<boolean>>
] {
	const [element, originalOpen] = useDataInputDialog<{}, boolean>(
		(_, onClose, onConfirm) => (
			<SaveChangesDialog
				onClose={onClose}
				onConfirm={onConfirm}
			/>
		)
	);

	const open = useCallback(
		(): Promise<TryResult<boolean>> => {
			return originalOpen({});
		},
		[originalOpen]
	);

	return [
		element,
		open
	];
}